if (!process.env.VUE_APP_IS_WEB) {
  var MeetingResolutionDB = require("../database/models/MeetingResolution");

  var ResolutionDB = require("../database/models/Resolution");
}
import settings from "@/database/settings";
import dates from "@/database/dates";
import strings from "@/database/strings";

import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";
import ResolutionORM from "@/store/orm-axios/models/Resolution";
import MediaORM from "@/store/orm-axios/models/Media";

import MediaMW from "./Media";
import { _ } from "vue-underscore";

export default {
  // TODO: On API we need to get children resolutions by position ASC
  FETCH(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingResolutionDB()
          .query({
            where: {
              meeting_id: meetingId,
              deleted: null,
              parent_resolution_id: null,
            },
          })
          .orderBy("position", "ASC")
          .fetchAll({
            withRelated: [
              {
                resolution_votes: query => {
                  query.where("deleted", null);
                },
              },
              {
                children_resolutions: query => {
                  query.where("deleted", null);
                  query.orderBy("position", "ASC");
                },
              },
            ],
          })
          .then(res => {
            // console.log("meeting resolutions", res.serialize());
            MeetingResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .FETCH(meetingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(agencyId, queryParams, relatedId) {
    if (!process.env.VUE_APP_IS_WEB) {
      var mainTable = "meeting_resolution";
      var relatedVotingCategoryTable = "voting_category";
      var relatedMajorityTable = "majority";
      return new Promise((resolve, reject) => {
        new MeetingResolutionDB()
          .query(qb => {
            qb.select(`${mainTable}.*`);
            qb.where(`${mainTable}.agency_id`, agencyId)
              .where(`${mainTable}.meeting_id`, relatedId)
              .whereNull(`${mainTable}.parent_resolution_id`)
              .whereNull(`${mainTable}.deleted`);

            // filter
            queryParams.filter.forEach(filter => {
              if (filter.column == "*meeting-resolutions-voting-category*") {
                qb.where(`${mainTable}.voting_category_id`, filter.value);
              } else if (filter.column == "*meeting-resolutions-majority*") {
                qb.where(`${mainTable}.majority_id`, filter.value);
              } else {
                qb.where(`${mainTable}.${filter.column}`, "LIKE", "%" + filter.value + "%");
              }
            });

            // order
            if (queryParams.sort.by == "*meeting-resolutions-voting-category*") {
              // HACK: order by the names of the voting categories they belong to
              qb.leftJoin(`${relatedVotingCategoryTable} as v`, function () {
                this.on(`v.id`, "=", `${mainTable}.voting_category_id`).onNull(`v.deleted`);
              }).orderBy(`v.name`, queryParams.sort.dir);
            } else if (queryParams.sort.by == "*meeting-resolutions-majority*") {
              // HACK: order by the names of the majorities they have
              qb.leftJoin(`${relatedMajorityTable} as m`, function () {
                this.on(`m.id`, "=", `${mainTable}.majority_id`).onNull(`m.deleted`);
              }).orderBy(`m.name`, queryParams.sort.dir);
            } else {
              qb.orderBy(`${mainTable}.${queryParams.sort.by}`, queryParams.sort.dir);
            }
          })
          .fetchPage({
            pageSize: settings.itemsPerPage,
            page: queryParams.page,
          })
          .then(res => {
            // console.log(res);
            MeetingResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .QUERY_FETCH(agencyId, queryParams, relatedId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingResolutionDB({
          id: id,
          deleted: null,
        })
          .fetch({
            withRelated: [
              "media",
              {
                children_resolutions: query => {
                  query.where("deleted", null);
                },
              },
              {
                resolution_votes: query => {
                  query.where("deleted", null);
                },
              },
              "children_resolutions.media",
            ],
          })
          .then(res => {
            MeetingResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .GET(id)
          .then(res => {
            // console.log("res", res);
            // ResolutionVoteORM.insertOrUpdate({
            //   data: res.response.data.resolution_votes,
            // });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async POST_FROM_RESOLUTIONS(item) {
    var meetingResolution = JSON.parse(JSON.stringify(item));
    var resolutionMedia = JSON.parse(JSON.stringify(meetingResolution.media));
    var childResolutions = [];
    if (meetingResolution.children_resolutions) {
      childResolutions = JSON.parse(JSON.stringify(meetingResolution.children_resolutions));
    }

    if (!process.env.VUE_APP_IS_WEB) {
      meetingResolution.slug = strings.get_slug(meetingResolution.name);
      meetingResolution.position = await this.setPosition(meetingResolution);
      return new Promise((resolve, reject) => {
        new MeetingResolutionDB(meetingResolution)
          .save()
          .then(async res => {
            if (childResolutions.length > 0)
              await this.POST_MULTIPLE_CHILD_RESOLUTIONS(childResolutions, res.serialize())
                .then(res => {
                  console.log("duplicate child resolutions res", res);
                  // HERE CREATE MEDIA FOR THE RESOLUTIONS
                  // console.log("childResolutions: ", childResolutions);
                  childResolutions.forEach(children => {
                    if (children.media.length > 0) {
                      res.data.forEach(async childResponse => {
                        if (
                          children.position == childResponse.position &&
                          children.name == childResponse.name
                        ) {
                          await MediaMW.POST_MULTIPLE_FOR_RESOLUTION(
                            children.media,
                            "meeting_resolution",
                            childResponse.id,
                            true
                          );
                        }
                      });
                    }
                  });
                })
                .catch(err => {
                  // console.log("duplicate child resolutions err", err);
                });

            if (resolutionMedia.length > 0)
              await MediaMW.POST_MULTIPLE_FOR_RESOLUTION(
                resolutionMedia,
                "meeting_resolution",
                res.serialize().id,
                true
              )
                .then(res => {
                  // console.log("duplicate media res", res);
                })
                .catch(err => {
                  // console.log("duplicate media err", err);
                });

            MeetingResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .POST(meetingResolution)
          .then(async res => {
            let childrenResolutionsResponse;
            if (childResolutions.length > 0) {
              await this.POST_MULTIPLE_CHILD_RESOLUTIONS(childResolutions, res.response.data)
                .then(res => {
                  console.log("duplicate child resolutions res", res);
                  childrenResolutionsResponse = res;
                  // HERE CREATE MEDIA FOR THE RESOLUTIONS
                  // console.log("childResolutions: ", childResolutions);
                  // NOTE: I've used this solution because underscore doesn't work here
                  childResolutions.forEach(children => {
                    if (children.media.length > 0) {
                      childrenResolutionsResponse.data.forEach(async childResponse => {
                        if (
                          children.position == childResponse.position &&
                          children.name == childResponse.name
                        ) {
                          this.DUPLICATE_MEDIA(childResponse, children.media);
                        }
                      });
                    }
                  });
                })
                .catch(err => {
                  // console.log("duplicate child resolutions err", err);
                });
            }
            if (resolutionMedia.length > 0) {
              this.DUPLICATE_MEDIA(res.response.data, resolutionMedia);
            }
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async POST_FROM_CATALOGS(items) {
    var meetingResolutions = JSON.parse(JSON.stringify(items));

    // NOTE: for success / error handling
    var data = [];
    var errors = [];

    for (var meetingResolution of meetingResolutions) {
      var resolutionMedia = JSON.parse(JSON.stringify(meetingResolution.media));
      var childResolutions = [];
      if (meetingResolution.children_resolutions) {
        childResolutions = JSON.parse(JSON.stringify(meetingResolution.children_resolutions));
      }

      if (!process.env.VUE_APP_IS_WEB) {
        meetingResolution.slug = strings.get_slug(meetingResolution.name);
        meetingResolution.position = await this.setPosition(meetingResolution);
        await new MeetingResolutionDB(meetingResolution)
          .save()
          .then(async res => {
            if (childResolutions.length > 0)
              await this.POST_MULTIPLE_CHILD_RESOLUTIONS(childResolutions, res.serialize())
                .then(res => {
                  // console.log("duplicate child resolutions res", res);
                })
                .catch(err => {
                  // console.log("duplicate child resolutions err", err);
                });

            // duplicate files ..
            if (resolutionMedia.length > 0)
              await MediaMW.POST_MULTIPLE_FOR_RESOLUTION(
                resolutionMedia,
                "meeting_resolution",
                res.serialize().id,
                true
              )
                .then(res => {
                  // console.log("duplicate media res", res);
                })
                .catch(err => {
                  // console.log("duplicate media err", err);
                });

            MeetingResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            data.push(res.serialize());
          })
          .catch(err => {
            errors.push(err);
          });
      } else {
        await MeetingResolutionORM.api()
          .POST(meetingResolution)
          .then(async res => {
            let childrenResolutionsResponse;
            if (childResolutions.length > 0)
              await this.POST_MULTIPLE_CHILD_RESOLUTIONS(childResolutions, res.response.data)
                .then(res => {
                  childrenResolutionsResponse = res;
                  childResolutions.forEach(children => {
                    if (children.media.length > 0) {
                      childrenResolutionsResponse.data.forEach(async childResponse => {
                        if (
                          children.position == childResponse.position &&
                          children.name == childResponse.name
                        ) {
                          this.DUPLICATE_MEDIA(childResponse, children.media);
                        }
                      });
                    }
                  });
                })
                .catch(err => {
                  // console.log("duplicate child resolutions err", err);
                });

            if (resolutionMedia.length > 0)
              this.DUPLICATE_MEDIA(res.response.data, resolutionMedia);

            data.push(res.response.data);
          })
          .catch(err => {
            errors.push(err);
          });
      }
    }

    return new Promise((resolve, reject) => {
      if (errors.length == 0) {
        resolve({
          status: "success",
          message: "The process completed successfully.",
          data: data,
        });
      } else {
        reject({
          status: "error",
          message: "There were some errors in the process.",
          errors: errors,
          data: data,
        });
      }
    });
  },
  PUT(item) {
    var itemPut = JSON.parse(JSON.stringify(item));

    if (!process.env.VUE_APP_IS_WEB) {
      itemPut.slug = strings.get_slug(itemPut.name);

      return new Promise((resolve, reject) => {
        new MeetingResolutionDB(itemPut)
          .save(null, {
            isUpdate: true,
          })
          .then(res => {
            console.log("res.serialize()", res.serialize());
            MeetingResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .PUT(itemPut)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new MeetingResolutionDB(itemDelete)
          .save(null, {
            isDelete: true,
          })
          .then(async res => {
            // TODO: FIXME: think/structure a functionality to do this kind of cascade/orphanRemoval from another/better place
            // delete orphan meeting resolutions
            for (var childResolution of itemDelete.children_resolutions) {
              await this.DELETE(childResolution);
            }

            // delete orphan media files
            await new MeetingResolutionDB({
              id: item.id,
            })
              .fetch({
                withRelated: ["media"],
              })
              .then(async res => {
                var mediaIds = [];
                var medias = res.serialize().media;
                medias.forEach(media => {
                  mediaIds.push(media.id);
                });

                await MediaMW.BULK_DELETE(mediaIds);
              })
              .catch(err => {
                console.error(err);
              });

            MeetingResolutionORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  // CHILD MEETING RESOLUTIONS
  async POST_MULTIPLE_CHILD_RESOLUTIONS(childResolutions, parentResolution) {
    var data = [];
    var errors = [];

    for (const childResolution of childResolutions) {
      var defaultChildResolution = {
        parent_resolution_id: parentResolution.id,
        meeting_id: parentResolution.meeting_id,
        agency_id: parentResolution.agency_id,

        name: childResolution.name,
        slug: strings.get_slug(childResolution.name),
        description: childResolution.description,

        majority_id: childResolution.majority_id,
        voting_category_id: parentResolution.voting_category_id,
        position: childResolution.position,
        media: childResolution.media,
      };

      if (!process.env.VUE_APP_IS_WEB) {
        await new MeetingResolutionDB(defaultChildResolution)
          .save()
          .then(res => {
            MeetingResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            data.push(res.serialize());
          })
          .catch(err => {
            console.log("error create child resolution", err);
            errors.push(err);
          });
      } else {
        // api call ..
        await MeetingResolutionORM.api()
          .POST(defaultChildResolution)
          .then(res => {
            data.push(res.response.data);
          })
          .catch(err => {
            errors.push(err);
          });
      }
    }

    return new Promise((resolve, reject) => {
      if (errors.length == 0) {
        resolve({
          status: "success",
          message: "The process completed successfully.",
          data: data,
        });
      } else {
        reject({
          status: "error",
          message: "There were some errors in the process.",
          errors: errors,
          data: data,
        });
      }
    });
  },

  async setPosition(resolution) {
    return new Promise((resolve, reject) => {
      if (resolution.meeting_id) {
        var meetingId = resolution.meeting_id;
        if (!process.env.VUE_APP_IS_WEB) {
          new MeetingResolutionDB()
            .query(qb => {
              qb.where(`meeting_id`, meetingId);
              qb.where(`deleted`, null);
            })
            .orderBy("position", "ASC")
            .fetchAll()
            .then(res => {
              res = res.serialize();
              let startPosition = 1;
              if (res.length > 0) {
                startPosition += res[res.length - 1].position;
              }
              return resolve(startPosition);
            })
            .catch(err => {
              console.log("setPosition err", err);
              return resolve(1000);
            });
        } else {
          MeetingResolutionORM.api()
            .GET_LAST_POSITION(meetingId)
            .then(res => {
              return resolve(res.response.data["lastPosition"]);
            })
            .catch(err => {
              errors.push(err);
            });
        }
      } else {
        console.error("something went wrong, meeting id was not set!");
        return resolve(1000);
      }
    });
  },
  async BULK_PUT(items) {
    var errors = [];
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        var counter = 0;
        for (let i = 0; i < items.length; i++) {
          let itemPut = items[i];
          new MeetingResolutionDB({ id: itemPut.id })
            .save(
              { position: itemPut.position },
              {
                isUpdate: true,
              }
            )
            .then(res => {
              counter++;
              // console.log("res", res.serialize());
              if (counter == items.length) {
                resolve();
              }
            })
            .catch(err => {
              // reject(err);
              counter++;
              errors.push(err);
              if (counter == items.length) {
                console.error(errors);
                reject(errors);
              }
            });
        }
      });
    } else {
      // TODO: !!!: ADD BULK PUT ON MEETING RESOLUTIONS ON API
      return new Promise((resolve, reject) => {
        var counter = 0;
        for (let i = 0; i < items.length; i++) {
          let itemPut = items[i];
          MeetingResolutionORM.api()
            .PUT(itemPut)
            .then(res => {
              // console.log("res: ", res);
              counter++;
              if (counter == items.length) {
                // console.error(errors);
                return resolve();
              }
            })
            .catch(err => {
              errors.push(err);
              counter++;
              if (counter == items.length) {
                console.error(errors);
                return reject();
              }
            });
        }
      });
    }
  },

  async DUPLICATE_MEDIA(meetingResolution, files) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .DUPLICATE_MEDIA(meetingResolution, files)
          .then(res => {
            // Save media manually because entity type is different than media
            if (res.response.data["hydra:member"]) {
              res.response.data["hydra:member"].forEach(data => {
                MediaORM.insertOrUpdate({
                  data: data,
                });
              });
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  SAVE_POSITION(items) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .SAVE_POSITION(items)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  UPDATE_RESOLUTIONS_NUMBERS(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .UPDATE_RESOLUTIONS_NUMBERS(meetingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async UPDATE_MEETING_RESOLUTION_WITH_MEDIA(meetingResolution, media, children_resolutions) {
    let mediaIds = [];
    media.forEach(element => {
      if (element.label) {
        mediaIds.push({
          id: element.id,
          label: element.label,
          keyId: element.keyId ? element.keyId : null,
          meeting_has_resolution_id: element.meeting_has_resolution_id
            ? element.meeting_has_resolution_id
            : null,
        });
      } else {
        mediaIds.push({
          id: element.id,
          label: element.name,
          keyId: element.keyId ? element.keyId : null,
          meeting_has_resolution_id: element.meeting_has_resolution_id
            ? element.meeting_has_resolution_id
            : null,
        });
      }
    });

    // Set media in resolution for reset
    meetingResolution.media = media.filter(
      m => m.meeting_has_resolution_id == meetingResolution.id
    );

    meetingResolution["mediaArray"] = mediaIds;
    meetingResolution["childrenResolutionArray"] = children_resolutions;
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation ..
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .UPDATE_MEETING_RESOLUTION_WITH_MEDIA(meetingResolution)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async CREATE_MEETING_RESOLUTION_WITH_MEDIA(meetingResolution, children_resolutions, media) {
    let mediaIds = [];
    media.forEach(element => {
      if (element.label) {
        mediaIds.push({
          id: element.id,
          label: element.label,
          keyId: element.keyId ? element.keyId : null,
          meeting_has_resolution_id: element.meeting_has_resolution_id
            ? element.meeting_has_resolution_id
            : null,
        });
      } else {
        mediaIds.push({
          id: element.id,
          label: element.name,
          keyId: element.keyId ? element.keyId : null,
          meeting_has_resolution_id: element.meeting_has_resolution_id
            ? element.meeting_has_resolution_id
            : null,
        });
      }
    });
    // Set media in resolution for reset
    meetingResolution.media = media.filter(m => m.keyId == undefined);

    meetingResolution["mediaArray"] = mediaIds;
    meetingResolution["childrenResolutionArray"] = children_resolutions;
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .CREATE_MEETING_RESOLUTION_WITH_MEDIA(meetingResolution)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  CREATE_DURING_MEETING(meetingResolution) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .CREATE_DURING_MEETING(meetingResolution)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE_DURING_MEETING(meetingResolution) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .DELETE_DURING_MEETING(meetingResolution)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },

  RESET(meetingResolution) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingResolutionORM.api()
          .RESET(meetingResolution)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
